import { jsxs as o, jsx as s } from "react/jsx-runtime";
import { T as c } from "../Tooltip-C5FFEkgJ.js";
const g = "320px", d = "600px", h = "1025px", y = "_isVisuallyHidden_1a3vz_51", m = "_comparisonContainer_1a3vz_63", p = "_valuesContainer_1a3vz_72", f = "_value_1a3vz_72", _ = "_label_1a3vz_80", v = "_progressBarContainer_1a3vz_107", z = "_progressBar_1a3vz_107", B = "_progress_1a3vz_107", H = "_leftBar_1a3vz_124", b = "_rightBar_1a3vz_129", u = "_lowerValue_1a3vz_134", W = "_separator_1a3vz_138", e = {
  mobile: g,
  "mobile-wide": "480px",
  tablet: d,
  "tablet-wide": "800px",
  desktop: h,
  "desktop-mid": "1281px",
  "desktop-large": "1360px",
  "heading-l": "--cxy-fontSize-xxxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-extraBold",
  "heading-l-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-extraBold",
  "heading-m": "--cxy-fontSize-xxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-semiBold",
  "heading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-semiBold",
  "heading-s": "--cxy-fontSize-xxl, --cxy-lineHeight-xl, --cxy-fontWeight-extraBold",
  "subHeading-l": "--cxy-fontSize-xl, --cxy-lineHeight-l, --cxy-fontWeight-bold",
  "subHeading-m": "--cxy-fontSize-l, --cxy-lineHeight-xs, --cxy-fontWeight-normal",
  "subHeading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-light",
  "subHeading-s": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "subHeading-s-mobile": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
  "button-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "button-s": "--cxy-fontSize-s, --cxy-lineHeight-xs, --cxy-fontWeight-semiBold",
  "button-xs": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
  "text-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "text-s": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
  "text-xs": "--cxy-fontSize-xs, --cxy-lineHeight-m, --cxy-fontWeight-semiBold",
  "text-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxxs, --cxy-fontWeight-normal",
  isVisuallyHidden: y,
  comparisonContainer: m,
  valuesContainer: p,
  value: f,
  label: _,
  progressBarContainer: v,
  progressBar: z,
  progress: B,
  leftBar: H,
  rightBar: b,
  lowerValue: u,
  separator: W
}, w = ({
  comparisonLabel: n,
  leftValue: i,
  rightValue: t,
  tooltipText: a,
  ...l
}) => {
  if (i + t !== 100)
    return console.warn(
      "Comparison component: The sum of leftValue and rightValue must equal 100."
    ), null;
  const r = `${i}%`, x = `${t}%`;
  return /* @__PURE__ */ o(
    "div",
    {
      className: e.comparisonContainer,
      role: "region",
      "aria-label": `${n} comparison bar with ${i}% on the left and ${t}% on the right.`,
      ...l,
      children: [
        /* @__PURE__ */ o("div", { className: e.valuesContainer, children: [
          /* @__PURE__ */ o("span", { "data-testid": "comparison-left", className: e.value, children: [
            i,
            "%"
          ] }),
          /* @__PURE__ */ o("div", { className: e.label, children: [
            n,
            " ",
            a && /* @__PURE__ */ s(c, { children: a })
          ] }),
          /* @__PURE__ */ o("span", { "data-testid": "comparison-right", className: e.value, children: [
            t,
            "%"
          ] })
        ] }),
        /* @__PURE__ */ o("div", { className: e.progressBarContainer, children: [
          /* @__PURE__ */ s(
            "div",
            {
              className: `${e.progressBar} ${i < t ? e.lowerValue : ""} ${e.leftBar}`,
              style: { width: r },
              children: /* @__PURE__ */ s("div", { className: e.progress })
            }
          ),
          /* @__PURE__ */ s("div", { className: e.separator }),
          /* @__PURE__ */ s(
            "div",
            {
              className: `${e.progressBar} ${t <= i ? e.lowerValue : ""} ${e.rightBar}`,
              style: { width: x },
              children: /* @__PURE__ */ s("div", { className: e.progress })
            }
          )
        ] })
      ]
    }
  );
};
export {
  w as Comparison
};
